module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '\n\nclass EquilibriumSettings {\n    \n}\n\nmodule.exports = EquilibriumSettings';

}
return __p
}